var version = {
    "name":      "dativery",
    "buildDateCode": "20251205-220218",
    "buildDate": "Fri Dec 05 2025 22:02:18 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251205-220218",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;